/**
 * Converts a given date to a string representation without the timezone information.
 * @param {Date} date - The date to convert.
 * @returns {string} A string representation of the date in ISO format, without the timezone information.
 */
export const dateWithoutTimezone = (date: Date) => {
  const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  const withoutTimezone = new Date(date.valueOf() - tzoffset)
    .toISOString()
    .slice(0, -1);
  return withoutTimezone;
};
